import React, { createContext, useState } from "react";
import Nullable from "../types/Nullable";
import { Uporabnik } from "../types/Uporabnik";
import { useEffect } from "react";
import useAddUporabnik from "../pages/login/LoginHooks";
import { useIsAuthenticated } from "@azure/msal-react";

export interface AuthContextProviderProps {
    loggedInUser?: Nullable<Uporabnik>;
    setLoggedInUser?: (uporabnik: Nullable<Uporabnik>) => void;
}

export const AuthContext = createContext<AuthContextProviderProps>({});

type AuthProviderArgs = {
    children?: React.ReactNode;
}

const AuthProvider = ({ children } : AuthProviderArgs) => {
    const [loggedInUser, setLoggedInUser] = useState<Nullable<Uporabnik>>();
    //const { instance, accounts } = useMsal();
    const addUporabnikMutatied = useAddUporabnik(setLoggedInUser);
    const isAuthenticated = useIsAuthenticated();

    useEffect(() => {
        if (isAuthenticated) {
            addUporabnikMutatied.mutate("", {
            onSuccess: () => {
                //navigate("/");
            },
            onError: (error) => {
                console.error("Error adding uporabnik:", error);
                // Optionally show a message to the user
            }
        });
        }
    }, []);

    return (
        <AuthContext.Provider value={
            {loggedInUser, setLoggedInUser}
        }>
            {children}
        </AuthContext.Provider>
    );
}

export { AuthProvider }